// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_4B","legend":"e_5B","legendContent":"e_6B","contentWrapper":"e_7B","fieldsetContent":"e_8B"};